export default __webpack_public_path__ + "6d780ad.png";